<template>
  <header class="d-flex align-items-center justify-content-between">
    <div class="logo"><span>M</span>SO</div>
    <DarkSwitcher />
  </header>
</template>

<script>
import DarkSwitcher from "./DarkSwitcher.vue";
export default {
  components: { DarkSwitcher },
};
</script>

<style lang="scss" scoped>
header {
  padding: 14px 50px;
  font-size: 3rem;
  border-bottom: 1px solid #444;
  color: var(--text-black-900);
  font-family: "Clicker script", cursive;
  background: var(--bg-black-950);
  .logo {
    span {
      color: var(--skin-color);
    }
  }
}
</style>
